import React from 'react'
import Modal from '../../../components/modal/modal'
import CloseSVG from '../../../assets/svg/close.svg'
import FormInput from '../../../components/form-input'
import { formValidation } from '../../../utils/functions'
import FormTextArea from '../../../components/form-textarea'
import Button from '../../../components/button'
import { useForm } from 'react-hook-form'
import { useSendBirthdayWish } from '../../../redux/company/hook'
import DOMPurify from 'dompurify'

const SendBirthdayWish = ({ isOpen, closeModal, employeeBirthday }) => {
  const {
    register,
    handleSubmit,
    formState: { isValid },
    errors,
  } = useForm({
    mode: 'onChange',
  })

  const { mutateAsync: sendWish, isLoading } = useSendBirthdayWish()

  const submit = (data) => {
    const message = DOMPurify.sanitize(data?.message)
    let payload = {
      employee_id: employeeBirthday?.id,
      message,
    }
    sendWish(payload).then((result) => {
      closeModal()
    })
  }

  return (
    <Modal
      scrollable={true}
      className='!min-w-[500px] max-w-[90%] !rounded-none'
      isOpen={isOpen}
      centered={true}
    >
      <form
        onSubmit={handleSubmit(submit)}
        className='flex flex-col w-full p-3  overflow-auto'
      >
        <div className='flex justify-between items-center'>
          <h1 className='text-[20px] font-medium'>Send Birthday Wish </h1>
          <div className='cursor-pointer' onClick={() => closeModal()}>
            <img src={CloseSVG} alt='close' />
          </div>
        </div>
        <hr className='divider mb-2' />
        <section className='flex flex-col gap-2'>
          <div className='w-full'>
            <FormInput
              label='Employee'
              name='employee'
              placeholder={'Selected employee'}
              type='text'
              disabled
              defaultValue={`${employeeBirthday?.first_name}  ${employeeBirthday?.last_name}`}
              error={errors.employee}
              errorMessage={errors.employee && errors.employee.message}
              inputRef={register(formValidation('text', true))}
            />
          </div>
          <div className='w-full'>
            <FormTextArea
              label={`Wish ${employeeBirthday?.first_name}  ${employeeBirthday?.last_name}`}
              name='message'
              type='text'
              placeholder={'Custom birthday message'}
              error={errors.message}
              readOnly={isLoading}
              errorMessage={errors.message && errors.message.message}
              inputRef={register(formValidation('text', true))}
            />
          </div>
          <div className='w-full h-full'>
            <Button
              text={'Send to Employee'}
              loading={isLoading}
              disabled={isLoading}
              type='submit'
              className='h-[40pxpx] w-full px-4'
            />
          </div>
        </section>
      </form>
    </Modal>
  )
}

export default SendBirthdayWish
